/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Scene_Description_CcprjInputs */

const en_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Shot Descriptions`)
};

const fr_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descriptions des plans d'importation`)
};

const de_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Shot Beschreibungen`)
};

const it_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizioni delle foto di importazione`)
};

const ru_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание импортированных кадров`)
};

const es_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripciones de tomas de importación`)
};

const zh_cn2_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入镜头描述`)
};

const ja_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートショットの説明`)
};

const hi_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण आयात करें`)
};

const pt_pt2_import_scene_description_ccprj = /** @type {(inputs: Import_Scene_Description_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrições de fotos de importação`)
};

/**
* | output |
* | --- |
* | "Import Shot Descriptions" |
*
* @param {Import_Scene_Description_CcprjInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_scene_description_ccprj = /** @type {((inputs?: Import_Scene_Description_CcprjInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Scene_Description_CcprjInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_import_scene_description_ccprj(inputs)
	if (locale === "de") return de_import_scene_description_ccprj(inputs)
	if (locale === "it") return it_import_scene_description_ccprj(inputs)
	if (locale === "ru") return ru_import_scene_description_ccprj(inputs)
	if (locale === "es") return es_import_scene_description_ccprj(inputs)
	if (locale === "zh-CN") return zh_cn2_import_scene_description_ccprj(inputs)
	if (locale === "ja") return ja_import_scene_description_ccprj(inputs)
	if (locale === "hi") return hi_import_scene_description_ccprj(inputs)
	if (locale === "pt-PT") return pt_pt2_import_scene_description_ccprj(inputs)
	return en_import_scene_description_ccprj(inputs)
});